/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Search_Criteria_Label_NameInputs */

const en_jobs_search_criteria_label_name = /** @type {(inputs: Jobs_Search_Criteria_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const de_jobs_search_criteria_label_name = /** @type {(inputs: Jobs_Search_Criteria_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const fr_jobs_search_criteria_label_name = /** @type {(inputs: Jobs_Search_Criteria_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const es_jobs_search_criteria_label_name = /** @type {(inputs: Jobs_Search_Criteria_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const it_jobs_search_criteria_label_name = /** @type {(inputs: Jobs_Search_Criteria_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const nl_jobs_search_criteria_label_name = /** @type {(inputs: Jobs_Search_Criteria_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam`)
};

const pl_jobs_search_criteria_label_name = /** @type {(inputs: Jobs_Search_Criteria_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazwa`)
};

const fi_jobs_search_criteria_label_name = /** @type {(inputs: Jobs_Search_Criteria_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nimi`)
};

const da_jobs_search_criteria_label_name = /** @type {(inputs: Jobs_Search_Criteria_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navn`)
};

const sv_jobs_search_criteria_label_name = /** @type {(inputs: Jobs_Search_Criteria_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namn`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Jobs_Search_Criteria_Label_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_search_criteria_label_name = /** @type {((inputs?: Jobs_Search_Criteria_Label_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Search_Criteria_Label_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_search_criteria_label_name(inputs)
	if (locale === "fr") return fr_jobs_search_criteria_label_name(inputs)
	if (locale === "es") return es_jobs_search_criteria_label_name(inputs)
	if (locale === "it") return it_jobs_search_criteria_label_name(inputs)
	if (locale === "nl") return nl_jobs_search_criteria_label_name(inputs)
	if (locale === "pl") return pl_jobs_search_criteria_label_name(inputs)
	if (locale === "fi") return fi_jobs_search_criteria_label_name(inputs)
	if (locale === "da") return da_jobs_search_criteria_label_name(inputs)
	if (locale === "sv") return sv_jobs_search_criteria_label_name(inputs)
	return en_jobs_search_criteria_label_name(inputs)
});